import {Query as ApolloQueryComp, Mutation as ApolloMutationComp} from "@apollo/client/react/components"
import {ApolloProvider, OperationVariables} from "@apollo/client"
import React, {PureComponent} from "react"

/** @deprecated don't be using apollo components, use hooks */
export class Query<TData = any, TVariables extends OperationVariables = OperationVariables> extends PureComponent<
  ApolloQueryComp<TData, TVariables>["propTypes"]
> {
  render() {
    // @ts-expect-error I don't really care
    return <ApolloQueryComp {...this.props} />
  }
}
/** @deprecated don't be using apollo components, use hooks */
export class Mutation<TData = any, TVariables extends OperationVariables = OperationVariables> extends PureComponent<
  ApolloMutationComp<TData, TVariables>["propTypes"]
> {
  render() {
    // @ts-expect-error I don't really care
    return <ApolloMutationComp {...this.props} />
  }
}

export type {QueryResult, MutationResult} from "@apollo/client"
export type MutationFn = never
export type MutationState = never
export {ApolloProvider}
export type ApolloProviderProps = React.ComponentProps<typeof ApolloProvider>
export type {MutationFunctionOptions as MutationProps, QueryFunctionOptions as QueryProps} from "@apollo/client"
export {NetworkStatus, ApolloError, ObservableQuery} from "@apollo/client"
export type {ApolloQueryResult, WatchQueryFetchPolicy} from "@apollo/client"
